export default __webpack_public_path__ + "static/media/hht1_ep5_minisitcom_02.69d42147.png";